import Admin from "./pages/Admin";
import HomeScaffold from "./pages/HomeScaffold";
import Login from "./pages/Login";
import OurServices from "./components/home/OurServices";
import Sample from "./components/home/Sample";
import SecondSample from "./components/home/SecondSample";
import MixedSlider from "./components/accesories/slider/MixedSlider";
import Home from "./components/home/Home"
import TopImageCard from "./components/accesories/card/TopImageCard";
import PersonnelCard from "./components/accesories/card/PersonnelCard";
import AboutUs from "./pages/Customer/AboutUs";
import ContactUs from "./pages/Customer/ContactUs";
import Blog from "./pages/Customer/Blog";
import BlogPage from "./pages/Customer/BlogPage";
import Projects from "./pages/Customer/Projects";
import ProjectPage from "./pages/Customer/ProjectPage";
import FAQs from "./pages/Customer/FAQs";
import Events from "./pages/Customer/Events";
import FinishedEventPage from "./pages/Customer/FinishedEventPage";
import EventPage from "./pages/Customer/EventPage";
import CategorizedBlogs from "./pages/Customer/CategorizedBlogs";
import CategorizedProjects from "./pages/Customer/CategorizedProjects";
import SearchBlogs from "./pages/Customer/SearchBlogs";
import NotFound from "./pages/Customer/NotFound";


const routes = [
    {
        path: "/",
        element: <HomeScaffold/>,
        children: [
            {path: "", element: <Home/>},
            {path: "/sample1", element: <Sample/>},
            {path: "/sample2", element: <SecondSample/>},
            {path: "/sample3", element: <MixedSlider/>},
            {path: "/contact-us", element: <ContactUs/>},
            {path: "/about-us", element: <AboutUs/>},
            {path: "/blogs", element: <Blog/>},
            {path: "/blogs/category/:id/posts/", element: <CategorizedBlogs/>},
            {path: '/blogs/:id', element: <BlogPage/>},
            { path: "/blogs/search", element: <SearchBlogs/> },
            {path: '/projects', element: <Projects/>},
            {path: "/projects/category/:id/posts/", element: <CategorizedProjects/>},
            {path: '/project/:id', element: <ProjectPage/>},
            {path: '/faq', element: <FAQs/>},
            {path: '/events', element: <Events/>},
            {path: '/finished_event/:id', element: <FinishedEventPage/>},
            {path: '/event/:id', element: <EventPage/>},
            {path: '*', element: <NotFound/>},

        ]
    },
    /*{
        path: "/admin",
        element: <Admin/>

    },
    {path: "/login", element: <Login/>},
    {path: "/not-authorized", element: <div>Access Denied</div>},*/
];

export default routes;